<template>
  <UCard
    :ui="{
      ring: '',
      divide: 'divide-y divide-gray-100 dark:divide-gray-800',
      header: 'bg-primary rounded-t-lg',
    }"
  >
    <template #header>
      <div class="flex items-center justify-between rounded-lg">
        <div class="flex items-center gap-2">
          <Icon :name="icon" class="w-6 h-6 text-white" />
          <h3 class="dj-modal-title">
            {{ title }}
          </h3>
        </div>

        <UButton
          variant="ghost"
          size="lg"
          icon="djust-icon:xmark"
          class="-my-1"
          @click="emit('close')"
        />
      </div>
    </template>
    <div class="dj-modal-content">
      <div class="dj-info text-left">
        {{ selectText }}
      </div>
      <USelectMenu
        v-model="selected"
        class="mt-6"
        size="lg"
        trailing-icon="djust-icon:down-select"
        :items="options || []"
        label-key="name"
        :placeholder="selectPlaceholder"
        :search-input="{
          placeholder: selectPlaceholder,
        }"
        :ui="{
          base: 'dj-input rounded-md w-full',
          option: 'rounded-md px-[8px] py-[6px]',
        }"
        @change="emit('select', selected.id)"
      >
        <template #trailing>
          <UIcon name="djust-icon:down-select" class="w-2 h-2" />
        </template>
        <template #empty>Aucune option</template>
      </USelectMenu>
      <USeparator class="mt-6" label="ou" type="dashed" />
      <div class="dj-info my-6 text-left">
        {{ createText }}
      </div>
      <UInput
        v-model="name"
        type="text"
        icon="djust-icon:pen"
        size="lg"
        color="white"
        trailing
        :placeholder="inputPlaceholder"
        :disabled="selected"
        :ui="{
          base: 'dj-input',
        }"
      />
    </div>
    <template #footer>
      <div class="flex items-center justify-center">
        <UButton
          size="lg"
          icon="i-heroicons-check"
          label="Créer"
          class="-my-1 bg-[var(--primary-color)] text-white"
          :disabled="isDisabled"
          @click="emit('submit', name)"
        />
      </div>
    </template>
  </UCard>
</template>

<script lang="ts" setup>
  defineProps({
    title: {
      type: String,
      required: true,
    },
    icon: {
      type: String,
      required: false,
      default: '',
    },
    selectText: {
      type: String,
      required: true,
    },
    selectPlaceholder: {
      type: String,
      required: false,
      default: '',
    },
    createText: {
      type: String,
      required: true,
    },
    inputPlaceholder: {
      type: String,
      required: false,
      default: '',
    },
    options: {
      type: Array<any>,
      required: true,
    },
  });
  const emit = defineEmits(['close', 'select', 'submit']);
  const name = ref('');
  const selected = ref<any>(null);

  const isDisabled = computed(() => !name.value && !selected.value);
</script>

<style lang="scss" scoped>
  @use './DjAddProductForm.scss';
</style>
